<template>
<div class="corpoConteudoInterno">
    <Topo :btnAcessoRestrito="true"></Topo>
    <Migalha label="Acessar Cadastro"></Migalha>
 <h1 class="text-primary text-xs-center p-b-30 p-t-30"><strong>ACESSE SEU CADASTRO</strong></h1>


  <p class="text-primary text-xs-center p-b-1 p-t-1" style=" margin-bottom: 16px">
    <strong>Versão: {{$t("label.versao")}}</strong>
  </p>
  

    <v-layout row wrap>
    <formCadastro ></formCadastro>
    <v-flex xs12 sm6>
    <div class="p-b-70 p-t-70 borderAjusteMovel movelDiplayBlock"><div class="border-top"></div></div>
    <formLogin ></formLogin>
    <br>
    <div class="p-b-30 p-t-30 borderAjusteMovel"><div class="border-top"></div></div>
    <br>
    <recuperarSenhaForm ></recuperarSenhaForm>
      </v-flex>
    </v-layout>
</div>
</template>
<script>
import formCadastro from "./components/form-cadastro";
import formLogin from "./components/form-login";
import recuperarSenhaForm from "./components/form-recuperarSenha";
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";

export default {
  name: "login",
  components: { /*Componentes utilizados*/
    formLogin,
    formCadastro,
    recuperarSenhaForm,
    Migalha,
    Topo
  },
  created() /*Metodo de start do componente*/{
    localStorage.removeItem('vuex');
    this.$store.commit("setToken",null);
    this.$store.commit("setTokenRefresh",null);
  },
  data() {//Declaracao de variaveis
    return {
    };
  },
  methods: {//Declaracao de todos os metodos
  }
};
</script>